import _ from 'underscore';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Row, Col } from 'reactstrap';
import { v4 as uuidV4 } from 'uuid';
import entityComposition from '../../common/classes/entityComposition';
import entityDropdownButtonFactory from '../../common/lookups/entityDropdownButtonFactory';
import DryFilmItem from './contractSpecDryFilmItem';
import SegmentedPicker from '../../common/controls/segmentedPicker';
const CoatTypeDropdown = entityDropdownButtonFactory('coatType');
class ContractSpecDryFilm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      thicknessUnits: 0
    }; // default thicknessUnits is 0

    this.handleAdd = this.handleAdd.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleThickUnitChange = this.handleThickUnitChange.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
  }
  componentDidMount() {
    const {
      coatTypeActions,
      coatType
    } = this.props;
    coatTypeActions.serverIndex(coatType.indexQuery);
  }
  handleChange(index, name, value) {
    const {
      onChange
    } = this.props;
    onChange(`dryFilms[${index}]/${name}`, value);
  }
  handleRemove(index) {
    const {
      onChange,
      active
    } = this.props;
    const dryFilms = JSON.parse(JSON.stringify(active.dryFilms));
    dryFilms.splice(index, 1);
    onChange('dryFilms', dryFilms);
  }
  handleAdd(coatType) {
    const {
      userID,
      active,
      onChange
    } = this.props;
    const {
      thicknessUnits
    } = this.state;

    // create a new dry film and add it to the array of existing dryFilms
    const newDryFilm = {
      id: uuidV4().toUpperCase(),
      appCreated: moment().utc().format('YYYY-MM-DD HH:mm:ss'),
      appCreatorID: userID,
      contractSpecID: active.id,
      thicknessUnits,
      coatTypeID: coatType.id
    };
    const {
      dryFilms
    } = active;
    dryFilms.push(newDryFilm);
    onChange('dryFilms', dryFilms);
  }

  // updates the thicknessUnits to reflect changes in the toggle switch
  handleThickUnitChange(newThickness) {
    const {
      active: {
        dryFilms
      },
      onChange
    } = this.props;
    // modify dryFilm entities with new thicknessUnit
    if (dryFilms.length) {
      dryFilms.forEach(dryFilm => {
        const df = dryFilm;
        df.thicknessUnits = newThickness;
      });
    }
    onChange('dryFilms', dryFilms);
    this.setState({
      thicknessUnits: newThickness
    });
  }
  render() {
    const {
      active: {
        dryFilms
      },
      coatType
    } = this.props;
    const {
      thicknessUnits
    } = this.state;
    let stateThicknessUnits = thicknessUnits;
    // if dryFilms already have a thicknessUnit, change default value
    if (dryFilms && dryFilms.length > 0) {
      if (dryFilms[0].thicknessUnits !== stateThicknessUnits) {
        stateThicknessUnits = dryFilms[0].thicknessUnits;
      }
    }

    // Grabs the id of the coat type that is stored
    const coatTypes = _.pluck(dryFilms, 'coatTypeID');
    const dryFilmItems = _.map(dryFilms, (nextDryFilm, dryFilmIndex) => /*#__PURE__*/React.createElement(DryFilmItem, {
      active: nextDryFilm,
      coatTypeList: coatType.list,
      index: dryFilmIndex,
      key: nextDryFilm.id,
      onChange: this.handleChange,
      onRemove: this.handleRemove,
      thicknessUnits: stateThicknessUnits
    }));
    return /*#__PURE__*/React.createElement("form", null, /*#__PURE__*/React.createElement("h2", null, "Dry Film Thickness"), /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      sm: {
        size: 3,
        offset: 9
      }
    }, /*#__PURE__*/React.createElement(SegmentedPicker, {
      names: ['Mils', 'Microns'],
      values: [0, 1],
      label: "Thickness Units",
      allowNull: false,
      onChange: this.handleThickUnitChange,
      value: stateThicknessUnits
    }))), /*#__PURE__*/React.createElement("div", null, dryFilmItems), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      sm: {
        size: 3,
        offset: 9
      }
    }, /*#__PURE__*/React.createElement(CoatTypeDropdown, {
      entity: "CoatType",
      enforceUnique: true,
      list: coatType.list,
      onAdd: this.handleAdd,
      title: "Add Coat",
      values: coatTypes
    }))));
  }
}
ContractSpecDryFilm.propTypes = {
  active: PropTypes.shape({
    id: PropTypes.string,
    dryFilms: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string,
      thicknessUnits: PropTypes.number
    }))
  }).isRequired,
  coatType: PropTypes.shape({
    indexQuery: PropTypes.shape({}),
    list: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  coatTypeActions: PropTypes.shape({
    serverIndex: PropTypes.func
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  userID: PropTypes.string.isRequired
};
export { ContractSpecDryFilm as TestContractSpecDryFilm };
export default entityComposition(ContractSpecDryFilm, ['coatType'], {});